import { OptionWithValues } from './option-with-values';

export class OptionRadio extends OptionWithValues {
    readonly type = 'radio';
}
